<template>
    <div id="page-header">
      <div id="page-header__content-wrapper">
        <div id="page-header__logo"><img src="../assets/static/logo2.png" /></div>
        <div id="page-header__title">{{ getTitle }}</div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'PageHeader',
  computed: {
    getTitle () {
      return this.$store.state.title
    }
  }
}
</script>

<style scoped lang="scss">
  #page-header{
    height:66px;
    background-color: #0095d4;
    width:100%;
  }
  #page-header__content-wrapper{
    width:100%;
    max-width: 1024px;
    margin: 0 auto;
    display: flex;
  }
  #page-header__logo{
    padding-top: 0;
    padding-left: 15px;
    width:150px;
    img{
      width: 100%;
      height:auto;
    }
  }
  #page-header__title{

    margin-left: auto;
    font-family: 'Bangers', 'Alegreya Sans', cursive;
    padding: 25px;
    color: white;
    letter-spacing: 1.5px;
  }
</style>
